import { Settings } from "@/components/ui/settings";
import { useThemePreference, type AppThemePreference } from "@/theme";
import { Stack } from "expo-router";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";

import { SafeAreaView } from "react-native-safe-area-context";
import { TEST_IDS } from "../../../testIdDefinition";

const THEME_OPTIONS: AppThemePreference[] = ["system", "light", "dark"];

export default function ThemeSwitch() {
    const { t } = useTranslation();
    const { preference, changeTheme } = useThemePreference();

    return (
        <SafeAreaView className="flex-1 bg-background" edges={["bottom"]}>
            <ScrollView
                className="flex-1"
                contentContainerClassName="gap-6 px-4 pb-6 pt-2 web:mx-auto web:w-full web:max-w-lg"
                testID={TEST_IDS[TEST_IDS.THEME_SCREEN]}
            >
                <Stack.Screen
                    options={{ title: t("settings.display.theme") }}
                />
                <Settings
                    title={t("settings.display.theme")}
                    footer={t("settings.display.themeFooter")}
                >
                    {THEME_OPTIONS.map((theme) => {
                        const selected = preference === theme;
                        return (
                            <Settings.Item
                                selected={selected}
                                key={theme}
                                label={t(`settings.display.theme-${theme}`)}
                                onPress={() => changeTheme(theme)}
                            />
                        );
                    })}
                </Settings>
            </ScrollView>
        </SafeAreaView>
    );
}
